import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "typeSelect", "destroyInput", "assigneeContainer", "statusContainer", "timeFields", "dependencyFields", "dependencySelect", "requiredStatusSelect" ]
  static values = { statesMap: Object }

  connect() {
    this.toggleFields()

    setTimeout(() => {
      this.updateRequiredStatuses()
    }, 200)
  }

  toggleFields() {
    const type = this.typeSelectTarget.value

    this.statusContainerTarget.classList.add("hidden")
    this.assigneeContainerTarget.classList.add("hidden")
    this.timeFieldsTarget.classList.add("hidden")
    this.dependencyFieldsTarget.classList.add("hidden")

    if (type === "") {
      if (this.hasDestroyInputTarget) this.destroyInputTarget.value = "1"
    } else {
      if (this.hasDestroyInputTarget) this.destroyInputTarget.value = "0"

      if (type === "time") {
        this.statusContainerTarget.classList.remove("hidden")
        this.assigneeContainerTarget.classList.remove("hidden")
        this.timeFieldsTarget.classList.remove("hidden")
      } else if (type === "dependency") {
        this.assigneeContainerTarget.classList.remove("hidden")
        this.statusContainerTarget.classList.remove("hidden")
        this.dependencyFieldsTarget.classList.remove("hidden")
        this.updateRequiredStatuses()
      }
    }
  }

  updateRequiredStatuses() {
    if (!this.hasDependencySelectTarget || !this.hasRequiredStatusSelectTarget) return

    const selectEl = this.dependencySelectTarget
    const requiredStatusSelect = this.requiredStatusSelectTarget
    const depTsInstance = selectEl.tomselect
    const statusTsInstance = requiredStatusSelect.tomselect

    if (!depTsInstance) return

    const selectedValues = depTsInstance.getValue()
    const valuesArray = Array.isArray(selectedValues) ? selectedValues : [selectedValues].filter(Boolean)

    const selectedTypes = valuesArray.map(id => {
      const optionData = depTsInstance.options[id]
      return optionData ? optionData.type : null
    }).filter(Boolean)

    const uniqueTypes = [...new Set(selectedTypes)]

    const savedValue = requiredStatusSelect.dataset.savedValue || (statusTsInstance ? statusTsInstance.getValue() : requiredStatusSelect.value)
    let availableStates = []

    if (uniqueTypes.length === 0) {
      availableStates = Object.values(this.statesMapValue).flat()
      availableStates = Array.from(new Map(availableStates.map(item => [item.value, item])).values())
    } else {
      const firstTypeStates = this.statesMapValue[uniqueTypes[0]] || []
      availableStates = firstTypeStates.filter(stateObj => {
        return uniqueTypes.every(type => {
          const typeStates = this.statesMapValue[type] || []
          return typeStates.some(s => s.value === stateObj.value)
        })
      })
    }

    if (availableStates.length === 0) {
      availableStates = [
        { value: "closed", label: "Завершена (готово или отменено)" }
      ]
    }  else {
      availableStates.unshift({ value: "closed", label: "Завершена (готово или отменено)" });
    }

    if (statusTsInstance) {
      statusTsInstance.clearOptions();

      availableStates.forEach(state => {
        statusTsInstance.addOption({ value: state.value, text: state.label });
      });

      if (availableStates.some(s => s.value === savedValue)) {
        statusTsInstance.setValue(savedValue);
      } else {
        statusTsInstance.setValue(availableStates[0]?.value);
      }
    } else {
      requiredStatusSelect.innerHTML = ""
      availableStates.forEach(state => {
        const option = document.createElement("option")
        option.value = state.value
        option.text = state.label
        if (state.value === savedValue) option.selected = true
        requiredStatusSelect.appendChild(option)
      })
    }
  }
}
